import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL} from "../../common/mapper";
import {formGroup, tableColumns} from "./config";
import MasterCabangFilter from "./masterCabangFilter";
import MasterCabangModifying from "./masterCabangModifying";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";
import {HttpStatus} from "../../common/Constants";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

class MasterCabang extends Component {
    tableColumns = [
        {
            name: "id",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        ...tableColumns,
        {
            name: "kodeCabang",
            label: "Action",
            options: {
                customBodyRender: (val) => {
                    return (
                        <div style={{width: "115px"}}>
                            <Button
                                className="btnAct"
                                style={{marginRight: 15, backgroundColor: "transparent"}}
                                onClick={() => this.handleModifyingVisibility(val)}
                            >
                                <i
                                    className="fa fa-lw fa-pencil-alt"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                            <Button
                                className="btnAct"
                                style={{marginRight: 15, backgroundColor: "transparent"}}
                                onClick={() => this.handleConfirmDelete(val)}
                            >
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </div>
                    );
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            submittedFilterData: {},
            filterVisible: false,
            modifyingVisible: false,
            loading: false,
            filterData: {},
            namaDealer: "",
            limit: 5,
            page: 1,
            totalData: 0,
            selectedData: null,
            provinceOptions: [],
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            dataTable: [],
            isFetch: false,
            showAlert: false,
            alertMessage: "",
            confirmDelete: false,
            deleteId: null,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (_, prevState) => {
        if ((prevState.page !== this.state.page || prevState.limit !== this.state.limit) && !this.state.isFetch) {
            this.handleTriggerLoading();
            await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
            this.handleTriggerLoading();
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    };

    refetchData = async () => {
        // await this.setState((prevValue) => ({
        //     ...prevValue,
        //     namaDealer: null,
        //     submittedFilterData: {},
        //     totalData: 0,
        // }));
        await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
    };

    fetchData = async (requestFilter = {}, page = 1, limit = 5) => {
        await this.setState((prevValue) => ({
            ...prevValue,
            isFetch: true,
        }));
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterCabang,
            menuName: "Master Cabang",
            setError: this.props.setError,
            args: {
                filter: requestFilter,
                page,
                limit,
            }
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                totalData: res.data.totalData,
                limit,
                page,
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleModifyingVisibility = async (kodeCabang) => {
        this.handleTriggerLoading();
        if (!R.isNil(kodeCabang)) {
            const response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterCabangById,
                menuName: "Master Cabang",
                setError: this.props.setError,
                args: kodeCabang,
            });
            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                const data = response.data.data;
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...response.data.data,
                        idProvince: !R.isNil(data.province)
                            ? mapToObjectDDL(data.province.provinceName, data.province.id)
                            : null,
                        idKecamatan: !R.isNil(data.kecamatan)
                            ? mapToObjectDDL(data.kecamatan.kecamatanName, data.kecamatan.id)
                            : null,
                        idKota: !R.isNil(data.kabkot)
                            ? mapToObjectDDL(data.kabkot.kabKotName, data.kabkot.kabKotId)
                            : null,
                        idWilayah: !R.isNil(data.wilayah)
                            ? mapToObjectDDL(data.wilayah.value, data.wilayah.key)
                            : null,
                        kodePos: !R.isNil(data.kodepos)
                            ? {
                                ...mapToObjectDDL(data.kodepos.zipcode, data.kodepos.zipcode),
                                kelurahanId: data.kodepos.id,
                            }
                            : null,
                        listAhmDealer: !R.isNil(data.listAhmDealer)
                            ? data.listAhmDealer.map(v=>mapToObjectDDL(v.value, v.key))
                            : null,
                        fotoGedungUrl: data.fotoGedungBase64,
                        fotoStampelUrl: data.fotoStampleBase64,
                        fotoMateraiUrl: data.fotoMateraiBase64,
                        fotoTemplateKwitansiUrl: data.fotoTemplateKwitansiBase64,
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
        this.handleTriggerLoading();
    };

    handleClickDelete = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterCabang,
            menuName: "Master Cabang",
            setError: this.props.setError,
            args: this.state.deleteId,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleConfirmDelete(null);
            this.handleShowAlert("Data berhasil dihapus.");
            await this.refetchData();
        }
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            ...this.getAllDDLValue(formGroup),
            listAhmDealer:  (controls?.listAhmDealer?.value || []).map(d => d.value),
            idKelurahan: !R.isNil(controls.kodePos.value) ? controls.kodePos.value.kelurahanId : "",
        };
        let res;
        if (!R.isNil(this.state.selectedData)) {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateMasterCabang,
                menuName: "Master Cabang",
                setError: this.props.setError,
                args: requestBody,
            });
        } else {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterCabang,
                menuName: "Master Cabang",
                setError: this.props.setError,
                args: requestBody,
            });
        }
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetchData();
            this.handleModifyingVisibility();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleSearch = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            filterData: {},
        }));
        await this.fetchData({
            namaDealer: this.state.namaDealer,
        }, 1 , this.state.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: {
                namaDealer: this.state.namaDealer,
            },
            loading: false,
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: tableState.page + 1,
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: 1,
            totalData: 1,
            limit: tableState.rowsPerPage,
        }));
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            namaDealer: "",
            page: 1,
            limit: this.state.limit
        }));
        const requestBody = {
            ...this.state.filterData,
            ...this.getAllDDLValue(this.state.filterData),
            ...(this.state.filterData && !R.isNil(this.state.filterData.kodePos)
                ? {idKelurahan: this.state.filterData.kodePos.kelurahanId}
                : {idKelurahan: ""}),
            status:
                !R.isNil(this.state.filterData) && getValueFromDDL(this.state.filterData, "status")
                    ? getValueFromDDL(this.state.filterData, "status")
                    : "ACTIVE",
        };
        await this.fetchData(requestBody, 1 , this.state.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            filterVisible: !prevValue.filterVisible,
            submittedFilterData: requestBody,
        }));
    };

    handleResetFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    handleDealerNameChange = (name, value) => {
        this.setState((prevValue) => ({...prevValue, [name]: value}));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    getAllDDLValue = (data) => {
        if (!R.isNil(data)) {
            return {
                idProvince: getValueFromDDL(data, "idProvince"),
                idKecamatan: getValueFromDDL(data, "idKecamatan"),
                idKota: getValueFromDDL(data, "idKota"),
                kodePos: getValueFromDDL(data, "kodePos"),
                idWilayah: getValueFromDDL(data, "idWilayah"),
            };
        }

        return {};
    };

    handleShowAlert = (alertMessage) => {
        this.setState((prevValue) => ({
            ...prevValue,
            showAlert: !prevValue.showAlert,
            alertMessage,
        }));
    };

    handleConfirmDelete = (id) => {
        this.setState((prevValue) => ({
            ...prevValue,
            confirmDelete: !prevValue.confirmDelete,
            deleteId: id,
        }))
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between"}}
                        vAlignContent="center"
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleInput
                                id="input_text_nama_dealer"
                                placeholder="Nama Dealer"
                                name="namaDealer"
                                containerclassname="margin-bottom-5px"
                                value={this.state.namaDealer}
                                onChange={({target}) => this.handleDealerNameChange(target.name, target.value)}
                            />
                            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                        </FlexView>
                        <Button
                            type="button"
                            className="btn background-red"
                            onClick={this.handleFilterVisibility}
                        >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                        </Button>
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                        toCount={this.state.totalData}
                        rowsPerPage={this.state.limit}
                        page={this.state.page - 1}
                        footerAdditionalButtons={
                            <SimpleButton onClick={() => this.handleModifyingVisibility()}>
                <span>
                  <i className="fa fa-plus margin-right-10px"></i>
                </span>
                                Tambah
                            </SimpleButton>
                        }
                    />
                </Container>
                {this.state.filterVisible && (
                    <MasterCabangFilter
                        state={this.state}
                        onReset={this.handleResetFilter}
                        onSubmit={this.handleSubmitFilter}
                        onSetState={this.handleStateChange}
                        onClickClose={this.handleFilterVisibility}
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterCabangModifying
                        formGroup={formGroup}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingVisibility}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}
                {this.state.showAlert && (
                    <SimpleAlert
                        visible={this.state.showAlert}
                        title={"Information"}
                        onClickClose={this.handleShowAlert}
                        content={this.state.alertMessage}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleShowAlert}>OK</SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.confirmDelete && (
                    <SimpleAlert
                        visible={this.state.confirmDelete}
                        title={"Information"}
                        onClickClose={this.handleConfirmDelete}
                        content={"Apakah anda yakin ingin menghapus data ini?"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleClickDelete}>Ya</SimpleButton>
                                <SimpleButton onClick={this.handleConfirmDelete}>
                                    Tidak
                                </SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterCabang);
